import { faInfoCircle, faTerminal } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid as MaterialGrid, Tooltip, Typography } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import React, { useEffect, useRef, useState } from 'react';
import { CheckboxColumnMenu, SimpleColumnMenu } from '../../../../libs/grid';
import useStylesGrid from '../../../../styles/grid.styles';
import LoadingPanel from '../../../../ui/old/Feedback/LoadingPanel';
import useStyles from '../../styles/useStyles';
import ImageStatus, { ESyncStatus } from '../ImageStatus';
import RelaticsDisplayErrorsDialog from './RelaticsDisplayErrorsDialog';
import RelaticsRealTimeLogDialogComponent from './RelaticsRealTimeLogDialog/RelaticsRealTimeLogDialogComponent';
import useRelaticsSyncLogsGrid from './useRelaticsSyncLogsGrid';
import useRelaticsDownloadXml from './useRelaticsDownloadXml';
import { AsiteDocumentsSyncClientLogDto } from '../../../../swagger';
import {  HubConnection } from '@microsoft/signalr';
import RelaticsDocumentsDialog from './RelaticsDocumentsDialog';
import { State } from '@progress/kendo-data-query';


interface RelaticsSyncLogsGridProps {
    gridState: State;
    setGridState: React.Dispatch<React.SetStateAction<State>>;
    connection: HubConnection | undefined;
}

const RelaticsSyncLogsGrid: React.FC<RelaticsSyncLogsGridProps> = ({gridState, setGridState, connection}) => {

    const { handleDownloadDocument } = useRelaticsDownloadXml();

    const classesGrid = useStylesGrid();
    const classes = useStyles();
    const {
        RelaticsSyncLogsQuery: { isLoading, isSuccess, refetch  },
        gridResult,
        handleDataStateChange,
    } = useRelaticsSyncLogsGrid(gridState, setGridState);

    const [gridData, setGridData] = useState(gridResult);
    const [displayErrorsDialogActive, setdisplayErrorsDialogActive] = useState(false);
    const [displayLogJobRunning, setDisplayLogJobRunning] = useState(false);
    const [documentsDialogActive, setDocumentsDialogActive] = useState(false);
    const [currentSelectedItem, setCurrentSelectedItem] = useState(undefined);
    
    const [idItemSelected, setIdItemSelected] = useState(0);
    
    const displayErrorsModal = (item: any) => {
        setIdItemSelected(item.id);
        setdisplayErrorsDialogActive(!displayErrorsDialogActive);
    };

    const displayLogJobRunningModal = () => {
        setDisplayLogJobRunning(!displayLogJobRunning);

    };

    useEffect(() => {
        setGridData(gridResult);
    }, [gridResult]);

    const [ data, setData ] =  useState<AsiteDocumentsSyncClientLogDto[]>([]);

    const dataMessgaes: any = useRef([]);
    dataMessgaes.current = data;

    useEffect(() => {
        if (connection?.state === 'Disconnected') {
            connection.start()
                .then(result => {
                    connection.on('RefetchGrid', (message: any) => {
                    if(message?.refetch) {
                        refetch();
                    }
                      console.log('message RefetchGrid', message)

                    });
                })
                .catch(e => console.error('Connection failed: ', e));
        }
    }, [connection]);
    return (
        <>
            {displayLogJobRunning && (
                <RelaticsRealTimeLogDialogComponent 
                    displayLogJobRunning={displayLogJobRunning}
                    setDisplayLogJobRunning={setDisplayLogJobRunning} 
                    data={data}
                    setData={setData}
                    connection={connection}
                    dataMessgaes={dataMessgaes}

                />
            )}
            {idItemSelected > 0 && (
                <RelaticsDisplayErrorsDialog
                    displayErrorsDialogActive={displayErrorsDialogActive}
                    setdisplayErrorsDialogActive={setdisplayErrorsDialogActive}
                    id={idItemSelected}
                />
            )}
            {currentSelectedItem && (
                <RelaticsDocumentsDialog
                    documentsDialogActive={documentsDialogActive}
                    setDocumentsDialogActive={setDocumentsDialogActive}
                    currentSelectedItem={currentSelectedItem}
                    handleDownloadDocument={handleDownloadDocument}
                />
            )}
            {isSuccess && (
                <Grid
                    className={classesGrid.grid + ' ' + classes.gridHeight}
                    pageable={{
                        buttonCount: 5,
                        type: 'numeric',
                        pageSizes: [5, 10, 20, 50],
                    }}
                    {...gridData}
                    {...gridState}
                    sortable={true}
                    filterable={false}
                    onDataStateChange={handleDataStateChange}
                >
                    <GridToolbar>
                        <MaterialGrid container style={{ minHeight: '30px' }}>
                            <Typography variant="h6" style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                                Logs
                            </Typography>
                        </MaterialGrid>
                    </GridToolbar>
                    <GridColumn
                        field="startDate"
                        title="Start Date"
                        format="{0:dd/MM/yyyy HH:mm:ss}"
                        filterable={false}
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        width={'200'}
                    />
                    <GridColumn
                        field="endDate"
                        title="End Date"
                        format="{0:dd/MM/yyyy HH:mm:ss}"
                        filterable={false}
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        width={'200'}
                    />
                    <GridColumn
                        field="status"
                        title="Status"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => (
                            <div className={'alignRight'}>
                                <CheckboxColumnMenu {...props} data={gridData?.data} />
                            </div>
                        )}
                        width={'90'}
                        cell={(props: any) => <ImageStatus {...props} />}
                    />
                     <GridColumn
                        field="relaticsConfigurationFolderFullPath"
                        title="Folder Configuration Path"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => <SimpleColumnMenu {...props} />}
                        width={'auto'}
                    />


                    <GridColumn
                        field="message"
                        title="Message"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => <SimpleColumnMenu {...props} />}
                        width={'auto'}
                    />
                    <GridColumn
                        field="emailSend"
                        title="Notified People"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        columnMenu={(props: any) => (
                            <div className={'alignRight'}>
                                <CheckboxColumnMenu {...props} data={gridData?.data} />
                            </div>
                        )}
                        width={'150'}
                    />
                    <GridColumn
                        title="Action"
                        headerClassName={classesGrid.gridColumnHeader}
                        className={classesGrid.gridColumn}
                        cell={(props) => {
                            if (
                                props?.dataItem.errorValidation &&
                                (props?.dataItem?.status == ESyncStatus.Warning ||
                                    props?.dataItem?.status == ESyncStatus.Success)
                            )
                                return (
                                    <>
                                        <td className={props.className}>
                                            <FontAwesomeIcon
                                                title="View errors"
                                                icon={faInfoCircle}
                                                className={
                                                    classes.baseFontAwesomeIcon + ' ' + classes.infoButtonIconErrors
                                                }
                                                onClick={() => {
                                                    displayErrorsModal(props?.dataItem);
                                                }}
                                            />
                                            <Tooltip title="Download XML files">
                                                <CloudDownloadIcon
                                                    className={
                                                        classes.baseFontAwesomeIcon +
                                                        ' ' +
                                                        classes.infoButtonIconDownload
                                                    }
                                                    onClick={() => {
                                                        setDocumentsDialogActive(!documentsDialogActive);
                                                        setCurrentSelectedItem(props.dataItem);
                                                    }}
                                                />
                                            </Tooltip>
                                        </td>
                                    </>
                                );
                                else if (props?.dataItem?.status == ESyncStatus.Running)
                                return (<td className={props.className}>

                                    <FontAwesomeIcon
                                        title="View Logs Real Time"
                                        icon={faTerminal}
                                        className={classes.baseFontAwesomeIcon + ' ' + classes.infoButtonIconErrors}
                                        onClick={() => {
                                            displayLogJobRunningModal();
                                        }}
                                        style={{color: 'green'}}
                                    />
                                </td>);
                            else if (
                                props?.dataItem?.status == ESyncStatus.Warning ||
                                props?.dataItem?.status == ESyncStatus.Success
                            )
                                return (
                                    <td className={props.className}>
                                        <Tooltip title="Download XML files">
                                            <CloudDownloadIcon
                                                className={
                                                    classes.baseFontAwesomeIcon + ' ' + classes.infoButtonIconDownload
                                                }
                                                onClick={() => {
                                                    setDocumentsDialogActive(!documentsDialogActive);
                                                    setCurrentSelectedItem(props.dataItem);
                                                }}
                                            />
                                        </Tooltip>
                                    </td>
                                );
                            else if (props?.dataItem.errorValidation)
                                return (
                                    <td className={props.className}>
                                        <FontAwesomeIcon
                                            title="View errors"
                                            icon={faInfoCircle}
                                            className={classes.baseFontAwesomeIcon + ' ' + classes.infoButtonIconErrors}
                                            onClick={() => {
                                                displayErrorsModal(props?.dataItem);
                                            }}
                                        />
                                    </td>
                                );
                            else
                                return (
                                    <>
                                        <td className={props.className}></td>
                                    </>
                                );
                        }}
                        width={'100'}
                        field={'errorValidation'}
                    />
                </Grid>
            )}
            {isLoading && <LoadingPanel />}
        </>
    );
};

export default RelaticsSyncLogsGrid;
